// extracted by mini-css-extract-plugin
export default {"container":"fEiUt","tabsContainer":"_17w4g","menuHeader":"SYlMw"};